import getActionsByDocument from '../../../../../components/logs/actions';

const DOCUMENT = 'USER_LOGS_';

export default getActionsByDocument(DOCUMENT);
